<template>
  <div class="form-step">
    <ion-grid class="form-step-content">
      <ion-row>
        <ion-col>
          <h1 class="form-question">
            I declare this inspection is true, accurate, and preformed by me.
          </h1>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <template v-if="!signature">
            <ion-button fill="clear" @click="openSignatureModal"
              >Add signature</ion-button
            >
          </template>
          <template v-else>
            <ion-item>
              <ion-label position="stacked">Signature</ion-label>
              <div class="signature-thumbnail">
                <img :src="signature" @click="openSignatureModal" />
              </div>
            </ion-item>
            <div class="ion-padding text-center">
              <div v-if="name">
                <span>{{ name }}</span>
              </div>
              <div>
                <span>{{ formatDate(date) }}</span>
              </div>
            </div>
          </template>
        </ion-col>
      </ion-row>
      <ion-row v-if="message">
        <ion-col>
          <slot name="invalid">
            <ion-chip color="danger">
              <ion-label>{{ message }}</ion-label>
            </ion-chip>
          </slot>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="form-step-end" v-if="signature">
      <ion-button v-if="loading" expand="block">
        <ion-spinner></ion-spinner>
      </ion-button>
      <ion-button v-else expand="block" @click="onSubmit">
        Submit
      </ion-button>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";

import SignaturePadModal from "../../components/SignaturePadModal.vue";

export default {
  name: "StepSubmit",
  props: ["value", "message", "data", "loading"],
  model: {
    prop: "value",
    event: "input"
  },
  computed: {
    name() {
      return this.data.name;
    },
    computedValue: {
      get() {
        return this.value || {};
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    signature: {
      get() {
        return this.computedValue.signature;
      },
      set(value) {
        this.$emit("input", { ...this.computedValue, signature: value });
      }
    },
    date: {
      get() {
        return this.computedValue.date;
      },
      set(value) {
        this.$emit("input", { ...this.computedValue, date: value });
      }
    }
  },
  methods: {
    openSignatureModal() {
      const onSignature = function(value) {
        this.computedValue = {
          signature: value,
          date: DateTime.local().toISO(),
          name: this.name
        };
      }.bind(this);
      return this.$ionic.modalController
        .create({
          component: SignaturePadModal,
          componentProps: {
            propsData: {
              onSignature
            }
          }
        })
        .then(modal => modal.present());
    },
    formatDate(iso) {
      return DateTime.fromISO(iso).toFormat("d LLL y, hh:mm a");
    },
    onSubmit() {
      this.$emit("submit");
    }
  }
};
</script>

<style lang="scss" scoped>
.signature-thumbnail {
  width: 100%;
  max-height: 100px;
  overflow: hidden;
  img {
    object-fit: contain;
    height: 100px;
    width: 100%;
  }
}
</style>
